import { Tag } from "antd";
import { EmptyCell } from "components/UI/Table/UI/EmptyCell/EmptyCell.tsx";

import LabelData = App.Data.LabelData;

interface LabelsCellProps {
    labels?: LabelData[] | null;
    maxDisplay?: number;
}

export const LabelsCell = ({ labels, maxDisplay = 3 }: LabelsCellProps) => {
    if (!labels || labels.length === 0) {
        return <EmptyCell />;
    }

    const displayLabels = maxDisplay !== undefined ? labels.slice(0, maxDisplay) : labels;
    const remainingCount = labels.length - displayLabels.length;

    return (
        <div className="flex flex-wrap gap-1">
            {displayLabels.map((label) => (
                <Tag key={label.id} color={label.color ?? undefined} className="!m-0">
                    {label.name}
                </Tag>
            ))}
            {remainingCount > 0 && (
                <Tag className="!m-0" color="default">
                    +{remainingCount}
                </Tag>
            )}
        </div>
    );
};
